export const QUANTITY_INPUT = {
  max_length: 3,
  max_value: 999,
  min_value: 1
}
